import {fontFamilies} from "./fontFamilies";
import {textPositions} from "./textPositions";

export const designers = [{
  video: {
    url: "https://player.vimeo.com/video/873373692",
  },
  name: "Will McLean",
  nationality: "Australian",
  role: <>Managing Director - <a href="http://supermarket.london" target="_blank" rel="noopener noreferrer">Supermarket</a></>,
  quote: "We can’t understate how beneficial we think the FVS concepts could be to our work. Currently the tool is just an exploration of what a design program using these concepts could look like. Given more time we think this could turn into a custom design program to deliver work for our clients.",
  preset: {
    colorScheme: 6,
    quad1: {
      color: "color6",
      shape: "quarterCircle",
      rotation: 180,
    },
    quad2: {
      color: "color1",
      shape: "triangle",
      rotation: 0,
    },
    quad3: {
      color: "color1",
      shape: "triangle",
      rotation: 0,
    },
    quad4: {
      color: "color1",
      shape: "square",
      rotation: 0,
    },
    animation: 'animateX',
    xCols: [36, 20, 10, 34],
    yRows: [30, 30, 30, 10],
    textTop: "SUPERMARKET",
    textBottom: "FLEXIBLE VISUAL SYSTEMS",
    textColor: "color3",
    textBGColor: "color4",
    textBGActive: true,
    fontFamily: fontFamilies[2],
    textPosition: textPositions[0],
    background: "color3",
    repetition: "mirrorTwo",
  },
}]